<mat-dialog-content aria-live="polite" class="width-550">
  <div [innerHTML]="error" class="bottom-space"></div>
</mat-dialog-content>

<mat-divider aria-hidden="true"></mat-divider>

<mat-dialog-actions align="end">
  <button mat-raised-button class="close-button" mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>